var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_1816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 13,
    height: 13,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_1816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74134 9.49171L9.56009 5.67296L8.80176 4.91462L5.74134 7.97504L4.19759 6.43129L3.43926 7.18962L5.74134 9.49171ZM6.49967 12.4167C5.75037 12.4167 5.0462 12.2745 4.38717 11.9901C3.72815 11.7058 3.15488 11.3198 2.66738 10.8323C2.17988 10.3448 1.79395 9.77157 1.50957 9.11254C1.2252 8.45351 1.08301 7.74935 1.08301 7.00004C1.08301 6.25073 1.2252 5.54657 1.50957 4.88754C1.79395 4.22851 2.17988 3.65525 2.66738 3.16775C3.15488 2.68025 3.72815 2.29431 4.38717 2.00994C5.0462 1.72556 5.75037 1.58337 6.49967 1.58337C7.24898 1.58337 7.95315 1.72556 8.61217 2.00994C9.2712 2.29431 9.84447 2.68025 10.332 3.16775C10.8195 3.65525 11.2054 4.22851 11.4898 4.88754C11.7742 5.54657 11.9163 6.25073 11.9163 7.00004C11.9163 7.74935 11.7742 8.45351 11.4898 9.11254C11.2054 9.77157 10.8195 10.3448 10.332 10.8323C9.84447 11.3198 9.2712 11.7058 8.61217 11.9901C7.95315 12.2745 7.24898 12.4167 6.49967 12.4167ZM6.49967 11.3334C7.7094 11.3334 8.73405 10.9136 9.57363 10.074C10.4132 9.23442 10.833 8.20976 10.833 7.00004C10.833 5.79032 10.4132 4.76567 9.57363 3.92608C8.73405 3.0865 7.7094 2.66671 6.49967 2.66671C5.28995 2.66671 4.2653 3.0865 3.42572 3.92608C2.58613 4.76567 2.16634 5.79032 2.16634 7.00004C2.16634 8.20976 2.58613 9.23442 3.42572 10.074C4.2653 10.9136 5.28995 11.3334 6.49967 11.3334Z",
    fill: "#0DBF8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.54e9555c9fea4bc4e3791bd10556392a.svg";
export { ForwardRef as ReactComponent };